"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireWildcard(require("react"));

var _dotUtils = require("dot-utils");

var _ramda = require("ramda");

var _md = require("react-icons/md");

var _styles = require("../styles");

var _Wrapper = _interopRequireDefault(require("../elements/Wrapper"));

var _BackgroundImage = _interopRequireDefault(require("../elements/BackgroundImage"));

var _Flex = _interopRequireDefault(require("../elements/Flex"));

var _GradientWrapper = _interopRequireDefault(require("../elements/GradientWrapper"));

var _Title = _interopRequireDefault(require("../elements/Title"));

var _Caption = _interopRequireDefault(require("../elements/Caption"));

var _Clickable = _interopRequireDefault(require("../elements/Clickable"));

var _Text = _interopRequireDefault(require("../elements/Text"));

var _statusColors;

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var statusColors = (_statusColors = {}, _defineProperty(_statusColors, _dotUtils.WidgetStatus.Draft, _styles.error), _defineProperty(_statusColors, _dotUtils.WidgetStatus.Published, _styles.success), _statusColors);

var defaultRender = function defaultRender(children) {
  return /*#__PURE__*/_react["default"].createElement(_Wrapper["default"], null, children);
};

var _StyledText = (0, _styledComponents["default"])(_Text["default"]).withConfig({
  displayName: "GridWidget___StyledText",
  componentId: "q12yzf-0"
})(["text-transform:uppercase;"]);

var _StyledClickable = (0, _styledComponents["default"])(_Clickable["default"]).withConfig({
  displayName: "GridWidget___StyledClickable",
  componentId: "q12yzf-1"
})(["border-radius:20px;overflow:hidden;position:relative;.grid-widget__hover-wrapper{background-color:rgba(0,0,0,0.8);color:#fff;font-size:25px;opacity:0;position:absolute;transition:0.35s opacity ", ";z-index:10;", ";", ";}&:hover{.grid-widget__hover-wrapper{opacity:1;}}"], _styles.easing, function (p) {
  return p._css;
}, _styles.fill);

var _StyledFlex = (0, _styledComponents["default"])(_Flex["default"]).withConfig({
  displayName: "GridWidget___StyledFlex",
  componentId: "q12yzf-2"
})(["text-transform:capitalize;"]);

function GridWidget(_ref) {
  var widget = _ref.widget,
      height = _ref.height,
      _ref$canEdit = _ref.canEdit,
      canEdit = _ref$canEdit === void 0 ? true : _ref$canEdit,
      _ref$onEdit = _ref.onEdit,
      onEdit = _ref$onEdit === void 0 ? function () {} : _ref$onEdit,
      _ref$canDelete = _ref.canDelete,
      canDelete = _ref$canDelete === void 0 ? true : _ref$canDelete,
      _ref$onDelete = _ref.onDelete,
      onDelete = _ref$onDelete === void 0 ? function () {} : _ref$onDelete,
      _ref$render = _ref.render,
      render = _ref$render === void 0 ? defaultRender : _ref$render,
      _ref$renderAfterConte = _ref.renderAfterContent,
      renderAfterContent = _ref$renderAfterConte === void 0 ? function () {
    return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null);
  } : _ref$renderAfterConte,
      _ref$onClick = _ref.onClick,
      _onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick;

  var bgImg = (0, _ramda.path)(['questions', 0, 'imgSrc'], widget);

  var iconRender = function iconRender(text, icon, onItemClick) {
    return /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
      alignItems: 'center',
      justifyContent: 'center',
      itemGap: 10
    }, icon, /*#__PURE__*/_react["default"].createElement(_StyledText, {
      fontSize: _styles.fontSizes.medium,
      fontWeight: 'bold',
      onClick: onItemClick,
      color: 'white'
    }, text));
  };

  return /*#__PURE__*/_react["default"].createElement(_StyledClickable, {
    height: height,
    onClick: function onClick() {
      return _onClick(widget);
    },
    _css: (0, _styles.pin)(0, 'top', 'left')
  }, render( /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_BackgroundImage["default"], {
    src: (0, _dotUtils.resolveImgSrc)(bgImg, true),
    height: height
  }), (canEdit || canDelete) && /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
    className: 'grid-widget__hover-wrapper',
    flexDirection: 'column',
    justifyContent: 'center',
    itemGap: 10
  }, canEdit && iconRender('Edit', /*#__PURE__*/_react["default"].createElement(_md.MdEdit, {
    fontSize: 'large'
  }), function () {
    return onEdit(widget);
  }), canDelete && iconRender('Delete', /*#__PURE__*/_react["default"].createElement(_md.MdDelete, {
    fontSize: 'large'
  }), function () {
    return onDelete(widget);
  })), /*#__PURE__*/_react["default"].createElement(_GradientWrapper["default"], {
    absolute: true,
    pt: _styles.baseSpacing * 6,
    px: _styles.baseSpacing * 2,
    pb: _styles.baseSpacing * 2
  }, /*#__PURE__*/_react["default"].createElement(_Title["default"], {
    mb: _styles.baseSpacing,
    color: 'white'
  }, widget.title), /*#__PURE__*/_react["default"].createElement(_StyledFlex, {
    mb: _styles.baseSpacing,
    alignItems: 'center',
    color: 'white'
  }, /*#__PURE__*/_react["default"].createElement(_Caption["default"], null, widget.type), /*#__PURE__*/_react["default"].createElement(_Caption["default"], {
    mx: _styles.baseSpacing / 2,
    component: 'span'
  }, "/"), /*#__PURE__*/_react["default"].createElement(_Caption["default"], {
    color: statusColors[widget.status]
  }, widget.status)), renderAfterContent(widget)))));
}

var _default = GridWidget;
exports["default"] = _default;